import {Mechanics} from '../../../types/Mechanics';
import {hasNestedData} from './hasNestedData';

type BrakeLiningWear = NonNullable<Mechanics>['brake']['brakeLiningWear'];

export function hasBrakeLiningWearInfo(brakeLiningWear: BrakeLiningWear, showEmptyFields: boolean) {
  if (showEmptyFields) {
    return true;
  }
  return hasNestedData(brakeLiningWear);
}
